import { render } from "./SkillDetails.vue?vue&type=template&id=a9e28e64&scoped=true"
import script from "./SkillDetails.vue?vue&type=script&lang=ts"
export * from "./SkillDetails.vue?vue&type=script&lang=ts"

import "./SkillDetails.vue?vue&type=style&index=0&id=a9e28e64&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a9e28e64"

export default script